interface Props {
    label: string;
}

export function EmploymentBreak({ label }: Props) {
    return (
        <div className="group flex gap-3">
            <div className="flex flex-col items-center">
                <div className="bg-grey-300 h-2 w-px group-first:invisible" />
                <div className="bg-grey-300 size-2.5 shrink-0 rounded-full" />
                <div className="bg-grey-300 w-px grow group-last:invisible" />
            </div>
            <div className="flex flex-1 flex-col pr-2.5 pb-4 group-last:pb-0">
                <div className="text-fg w-fit rounded-md bg-[repeating-linear-gradient(45deg,var(--color-grey-200)_0px,var(--color-grey-200)_15px,var(--color-grey-50)_15px,var(--color-grey-50)_30px)] px-3 py-2 text-sm">
                    {label}
                </div>
            </div>
        </div>
    );
}
